<template>
  <div class="d-block d-md-none">{{ column }}</div>
  <div>
    <div v-if="!item.empty" class="d-flex flex-column">
      <span class="fw-bold d-flex align-items-center">
        <FontAwesomeIcon v-if="item.baseline" icon="fa-light fa-calendar-arrow-down" class="me-2" />
        {{ item.text }}
      </span>
      <span v-if="item.baseline" class="dataTable__baseline fw-bold -date">
        <FontAwesomeIcon v-if="item.baseline" icon="fa-light fa-calendar-arrow-up" class="me-2" />{{ item.baseline }}
      </span>
    </div>
    <div v-else class="dataTable__empty">{{ item.empty }}</div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "DateCellDataTableComponent",
  components: { FontAwesomeIcon },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: String,
      required: true,
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
